import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { DeskingOffer } from '@upstart/harmony/lib/legos/deskingTypes';
import {
  FullCashOffer,
  FullLeaseOffer,
  FullPurchaseOffer,
} from '@upstart/harmony/lib/legos/paymentTypes';
import {
  offerHistorySuccess,
  offerHistoryFailure,
  versionSnapshotsSuccess,
  versionSnapshotsFailure,
  restoreVersionSuccess,
  restoreVersionFailure,
} from './actions';
import {
  OFFERHISTORY_REQUEST,
  RESTOREVERSION_REQUEST,
  VERSIONSNAPSHOTS_REQUEST,
} from './actionTypes';
import { setDeskingOffers } from '../desking/actions';
import {
  setLatestRequestDate,
  deskingBulkPaymentSuccess,
} from '../deskingPayments/actions';

import DeskingService from '../../services/DeskingService';

export function* getOfferHistoryTask(action: any): Generator<any, void, any> {
  const { deskingOfferId }: { deskingOfferId: string } = action.payload;
  try {
    const response = yield call(DeskingService.getOfferHistory, deskingOfferId);
    yield put(offerHistorySuccess(response));
  } catch (error) {
    yield put(offerHistoryFailure(error));
  }
}

interface GetVersionSnapshotsPayload {
  deskingId: string;
  deskingOfferId: string;
  version: number;
}

export function* getVersionSnapshotsTask(
  action: any,
): Generator<any, void, any> {
  const {
    deskingId,
    deskingOfferId,
    version,
  }: GetVersionSnapshotsPayload = action.payload;
  try {
    const response = yield call(
      DeskingService.getVersionSnapshots,
      deskingId,
      deskingOfferId,
      version,
    );
    yield put(versionSnapshotsSuccess(response));
  } catch (error) {
    yield put(versionSnapshotsFailure(error));
  }
}

export interface OfferAndPayment {
  deskingOffer: DeskingOffer;
  payment: Partial<FullPurchaseOffer | FullLeaseOffer | FullCashOffer>;
}

export function* restoreVersionTask(action: any): Generator<any, void, any> {
  const {
    deskingOfferId,
    version,
  }: { deskingOfferId: string; version: number } = action.payload;
  try {
    const collection: OfferAndPayment[] = yield call(
      DeskingService.restoreVersion,
      deskingOfferId,
      version,
    );
    yield put(restoreVersionSuccess(collection));
    yield put(
      setDeskingOffers(collection.map(({ deskingOffer }) => deskingOffer)),
    );
    const deskingOfferIds = collection.map(
      ({ deskingOffer }) => deskingOffer.id,
    );
    const requestDate = new Date();
    yield put(setLatestRequestDate({ requestDate, deskingOfferIds }));
    yield all(
      collection.map(({ payment, deskingOffer }) => {
        const paymentWithId = { ...payment, deskingOfferId: deskingOffer.id };
        return put(
          deskingBulkPaymentSuccess({
            payment: paymentWithId,
            requestDate,
          }),
        );
      }),
    );
  } catch (error) {
    yield put(restoreVersionFailure(error));
  }
}

export function* pencilHistorySaga() {
  yield takeLatest(OFFERHISTORY_REQUEST, getOfferHistoryTask);
  yield takeLatest(VERSIONSNAPSHOTS_REQUEST, getVersionSnapshotsTask);
  yield takeEvery(RESTOREVERSION_REQUEST, restoreVersionTask);
}
